import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/sagas/userMenu/userMenu";
import WebcamCapture from "../../../../components/webcamCapture/webcamCapture";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";
import ImageUpload from "../../../../components/imageUpload/imageUpload";
import { ArrowIcon } from "../../../../../assets/images/svg";

export function AvatarUpload({ id, organization_id, showCamera, showUpload, handleState }) {
  const dispatch = useDispatch();

  const imageUploading = useSelector((state) => state.userMenu.imageUploading);

  const saveImage = (data, id, orgId) => {
    dispatch(
      actionCreators.uploadImage({
        img: data,
        id: id,
        orgId: orgId
      })
    );
  };

  const renderHeader = ({ title = "Profile Image Preview", type }) => {
    return (
      <div className="avatar-upload__title">
        <div className="back" onClick={() => handleState(type, false)}>
          <ArrowIcon />
        </div>
        <div className="title">{title}</div>
      </div>
    );
  };

  const renderLoader = () => {
    return (
      imageUploading && (
        <div className="loading-overlay">
          <LoadingAnimation uiLoader />
        </div>
      )
    );
  };

  return (
    <>
      {showCamera && (
        <>
          {renderHeader({ type: "showCamera" })}

          {renderLoader()}

          <WebcamCapture
            uploadImage={(data) => saveImage(data, id, organization_id)}
            width={200}
            height={200}
            circle
            cta="Capture"
          />
        </>
      )}

      {showUpload && (
        <>
          {renderHeader({ type: "showUpload" })}

          {renderLoader()}

          <ImageUpload uploadImage={(data) => saveImage(data, id, organization_id)} cta="Capture" />
        </>
      )}
    </>
  );
}
